import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { PERIOD } from '../../common/constants';
import ContributorRow from '../ContributorRow';
import MultiDatePicker from '../../common/MultiDatePicker';
import ContentCard from '../ContentCard';
import { DROPDOWNDATA } from './constants';
import { DROPDOWN_VARIANTS } from '../constants';
import LoadingComponent from '../LoadingComponent';
import { noop } from '../propTypes';
import './styles.scss';

function TopContributors(
    {
        onSelect,
        topContributors,
        loading,
        className,
        downloadable,
        onDownloadClick,
        subheading,
        showSecondDd,
        challengeCodes,
        challengeCodesLoading,
        onChangeMode,
    },
    ref,
) {
    const [showDates, setShowDates] = useState(false);
    const [dateSelection, setDateSelection] = useState(DROPDOWNDATA[0].key);
    const [customDateSelected, setCustomDateSelection] = useState('');

    const onSelectionClicked = (selection) => {
        setDateSelection(selection);
        if (PERIOD.CUSTOM === selection) {
            setShowDates(true);
        } else {
            onSelect(selection);
            setShowDates(false);
        }
    };

    const onSelectionClicked2 = (selection) => {
        if (PERIOD.CUSTOM === dateSelection) {
            onChangeMode(selection);
            onSelect(PERIOD.CUSTOM, customDateSelected);
        } else {
            onChangeMode(selection);
            onSelect(dateSelection);
        }
    };

    const loader = <LoadingComponent isLoading={loading} />;
    const CustomDateSelector = showDates && (
        <MultiDatePicker
            onDatesSelected={(customDate) => {
                onSelect(PERIOD.CUSTOM, customDate);
                setCustomDateSelection(customDate);
            }}
        />
    );
    const rows =
        topContributors &&
        topContributors.map((contributor, index) => {
            return (
                <ContributorRow
                    imageSource={contributor.profilePicture}
                    name={contributor.fullName}
                    litterCount={contributor.litters}
                    rowNumber={index + 1}
                    key={`contributor-${index}`}
                />
            );
        });

    const cardContent = loading ? (
        <>{loader}</>
    ) : topContributors && topContributors.length ? (
        <>
            <div className="ScrollListing custom-scroll">
                <div className="row">
                    <div className="col">{rows}</div>
                </div>
            </div>
        </>
    ) : (
        <>
            <div className="empty-contributors-card">
                <span className="info">No Data Available</span>
            </div>
        </>
    );

    const mainContent = (
        <>
            {CustomDateSelector}
            {cardContent}
        </>
    );

    return (
        <ContentCard
            heading={'Top Contributors'}
            subHeading={subheading ? subheading : null}
            showDropDown
            showSecondDd={showSecondDd}
            loadingSecondDd={challengeCodesLoading}
            dropDownOnClick2={onSelectionClicked2}
            dropDownLabel2="Team"
            dropDownData2={challengeCodes}
            dropDownOnClick={onSelectionClicked}
            dropDownData={DROPDOWNDATA}
            dropDownVariant={DROPDOWN_VARIANTS.LIST_SIMPLE}
            content={mainContent}
            className={className}
            id="TopContributors"
            downloadable={downloadable}
            onDownloadClick={onDownloadClick}
            ref={ref}
        />
    );
}

TopContributors.propTypes = {
    // function to be called when drop down value is selected
    onSelect: PropTypes.func,
    onChangeMode: PropTypes.func,
    // contributors to be listed in component
    topContributors: PropTypes.arrayOf(PropTypes.object),
    // boolean value to determine whether to show the loader
    loading: PropTypes.bool,
    className: PropTypes.string,
    downloadable: PropTypes.bool,
    onDownloadClick: PropTypes.func,
    subheading: PropTypes.string,
    showSecondDd: PropTypes.bool,
    challengeCodes: PropTypes.array,
    challengeCodesLoading: PropTypes.bool,
};

TopContributors.defaultProps = {
    onSelect: noop,
    onChangeMode: noop,
    topContributors: [],
    loading: false,
    className: '',
    downloadable: false,
    onDownloadClick: noop,
    subheading: '',
    showSecondDd: false,
    challengeCodes: [],
    challengeCodesLoading: false,
};

export default React.forwardRef(TopContributors);
